import React from 'react'
import CheckboxForm from '@App/kit/fields/v2/CheckboxForm'
import FormFieldProps, { FormFieldType } from '@App/forms/v2/common/form-field'

interface TermsAndCommunicationsSectionProps {
    termsAndConditions: FormFieldType<boolean>
    privacyPolicy: FormFieldType<boolean>
}

const TermsAndCommunicationsSection = (props: TermsAndCommunicationsSectionProps) => {
    const { termsAndConditions, privacyPolicy } = props

    return (
        <div className="checks-wrapper">
            <div className="checkbox">
                {/* todo: do the below */}
                {/* Note: Had to use an AS here because I dont think formFieldFromProps handles children yet */}
                <CheckboxForm {...(termsAndConditions as FormFieldProps)}>
                    <a
                        href="https://www.themlc.com/portaltermsofuse"
                        target="_blank"
                        className="small"
                        rel="noreferrer"
                    >
                        Terms of Use
                    </a>
                </CheckboxForm>
            </div>
            <div className="checkbox">
                <CheckboxForm {...(privacyPolicy as FormFieldProps)}>
                    <a href="https://www.themlc.com/privacy-policy" target="_blank" className="small" rel="noreferrer">
                        Privacy Policy
                    </a>
                </CheckboxForm>
            </div>
        </div>
    )
}

export default TermsAndCommunicationsSection
